import React from "react";
import "./howitworks.css";

const HowItWorks = () => {
  return (
    <div className="maindiv howitworksmain">
      <section className="flex items-center justify-center sticky top-0">
        <div className="stepshow">
          <div>
            <div className="subscription-model">
              <h4 className="numner">01</h4>
              <h5 className="name">Subscription Model</h5>
              <p>
                Choosing the right meal plan is easy with our flexible
                subscription model. Sign up for a subscription that fits your
                lifestyle and preferences, and enjoy nutritious meals delivered
                right to your door.
              </p>
              <ul className="food-order-list">
                <li>
                  <span>🥗</span> <strong>Choose Your Plan</strong>
                  <p>
                    Select from weekly, bi-weekly, or monthly subscriptions to
                    suit your needs.
                  </p>
                </li>
                <li>
                  <span>🍔</span> <strong>Modify Anytime</strong>
                  <p>
                    Change or cancel your subscription as needed, no strings
                    attached.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <h4 className="numner">02</h4>
            <h5 className="name">How to Subscribe</h5>
            <p>
              Getting started with Bhookr is a breeze! Follow these simple steps
              to join our community of health-conscious eaters:
            </p>
            <ul>
              <li>
                <span>🌐</span> <strong>Visit our website:</strong>
                <p>Navigate to our Subscription Plans page.</p>
              </li>
              <li>
                <span>🍽️</span> <strong>Select your meal preferences:</strong>
                <p>
                  Choose from Veg, Non-Veg, or Vegan options based on your
                  dietary needs.
                </p>
              </li>
              <li>
                <span>📝 </span>
                <strong>Fill in your details:</strong>
                <p>
                  Enter your delivery information and select your preferred
                  delivery frequency.
                </p>
              </li>
              <li>
                <span>💳</span> <strong>Make your payment:</strong>
                <p>
                  Secure your subscription with our easy online payment options.
                </p>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="numner">03</h4>

            <h5 className="name">Meal Customization</h5>
            <p>
              At Bhookr, we believe that personalization is key to a successful
              meal plan. Customize your meals to meet your specific health
              goals, dietary restrictions, or culinary preferences.
            </p>
            <ul className="customization-list">
              <li>
                <span>🍽️</span> <strong>Select Your Ingredients</strong>
                <p>
                  Choose from a variety of base proteins, veggies, and grains to
                  create meals that satisfy your cravings.
                </p>
              </li>
              <li>
                <span>⚖️</span> <strong>Adjust Macros</strong>
                <p>
                  Tailor your meals to fit your macro requirements, ensuring you
                  meet your fitness objectives.
                </p>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="numner">04</h4>
            <h5 className="name">Live Orders</h5>
            <p>
              Stay connected with your meal progress through our live order
              tracking feature. No more wondering when your meals will arrive!
            </p>
            <ul className="order-tracking-list">
              <li>
                <span>📲</span> <strong>Real-Time Updates</strong>
                <p>
                  Receive notifications on meal preparation, dispatch, and
                  delivery.
                </p>
              </li>
              <li>
                <span>🗺️</span> <strong>Convenient Tracking</strong>
                <p>Keep an eye on your order right from our app or website.</p>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="numner">05</h4>
            <h5 className="name">Real-Time Ordering Process</h5>
            <p>
              Our efficient ordering system ensures that you receive hot and
              fresh meals without any hassle.
            </p>
            <ul className="ordering-features-list">
              <li>
                <span>⏰</span> <strong>Order Anytime</strong>
                <p>
                  Place single meal orders on-demand or schedule your meals in
                  advance.
                </p>
              </li>
              <li>
                <span>🤝</span> <strong>Seamless Integration</strong>
                <p>
                  We partner with delivery platforms like Zomato and Swiggy to
                  ensure quick and reliable delivery right to your doorstep.
                </p>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="numner">06</h4>
            <h5 className="name">Quality Assurance</h5>
            <p>
              Your health is our priority. Bhookr is committed to maintaining
              the highest standards in food quality and safety.
            </p>
            <ul className="quality-features-list">
              <li>
                <span>🥬</span>
                <strong>Fresh, Locally Sourced Ingredients</strong>
                <p>
                  We work with trusted suppliers to provide the freshest
                  ingredients for every meal.
                </p>
              </li>
              <li>
                <span>👨‍🍳</span> <strong>Health-Focused Preparation</strong>
                <p>
                  Our meals are prepared in a hygienic environment by
                  experienced chefs to ensure quality and safety.
                </p>
              </li>
              <li>
                <span>🥗</span> <strong>Nutritional Value Guaranteed</strong>
                <p>
                  Each meal is crafted to provide optimal nutrition, balancing
                  taste and health.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowItWorks;
